<div class="layout flex overflow-hidden">
  <aside class="panel w-80 p-4 overflow-y-auto border-r border-neutral-200 dark:border-neutral-800 flex flex-col gap-4">
    <h3 class="text-lg font-bold">Configuração da etiqueta</h3>

    @if (alertMessage()) {
      <app-alert [type]="alertType()" (click)="alertMessage.set(null)" class="cursor-pointer">
        {{ alertMessage() }}
      </app-alert>
    }

    <form [formGroup]="form" (ngSubmit)="save()" class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        <label class="flex flex-col gap-1 text-sm font-medium">
          Nome (máx 64)
          <input type="text" class="border w-full p-2 rounded" maxlength="64"
                 formControlName="name">
          @if (form.get('name')?.invalid && (form.get('name')?.dirty || form.get('name')?.touched)) {
            <span class="text-xs text-red-500">O nome deve ter entre 3 e 64 caracteres.</span>
          }
        </label>
        <label class="flex flex-col gap-1 text-sm font-medium">
          Descrição (máx 255)
          <textarea class="border w-full p-2 rounded text-sm" rows="2" maxlength="255"
                    formControlName="description"></textarea>
          @if (form.get('description')?.invalid && (form.get('description')?.dirty || form.get('description')?.touched)) {
            <span class="text-xs text-red-500">A descrição deve ter entre 3 e 255 caracteres.</span>
          }
        </label>
      </div>

      <app-button type="submit" [fullWidth]="true" [loading]="isSaving()">
        SALVAR
      </app-button>
    </form>

    <hr class="border-neutral-200 dark:border-neutral-800">

    <div class="flex gap-2">
      <label class="flex-1 flex flex-col gap-1 text-sm font-medium">
        Largura (mm)
        <input type="number" class="border w-full p-2 rounded" [value]="label().widthMm"
          (input)="setLabel({widthMm: +$any($event.target).value})">
      </label>
      <label class="flex-1 flex flex-col gap-1 text-sm font-medium">
        Altura (mm)
        <input type="number" class="border w-full p-2 rounded" [value]="label().heightMm"
          (input)="setLabel({heightMm: +$any($event.target).value})">
      </label>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-sm font-medium">Cor de fundo</span>
      <div class="flex gap-2 items-center">
        <input type="color" class="h-10 w-20 p-1 border rounded" [value]="label().backgroundColor"
          (input)="setLabel({backgroundColor: $any($event.target).value})">
        <app-button size="small" (click)="setLabel({backgroundColor: 'transparent'})" color="danger"
          [icon]="'trash'"></app-button>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-sm font-medium">Imagem de fundo</span>
      <label class="flex flex-col gap-1 text-sm">
        URL
        <input type="text" class="border p-2 rounded text-xs" [value]="label().backgroundImageUrl ?? ''"
          (input)="setLabel({backgroundImageUrl: $any($event.target).value || undefined})" placeholder="https://...">
      </label>
      <div class="flex flex-col gap-1">
        <span class="text-xs text-neutral-500">Ou upload (JPG/PNG, máx. {{ maxFileSizeMb }}MB)</span>
        <input type="file" accept="image/jpeg,image/png,.jpg,.jpeg,.png" class="text-xs"
          (change)="onBackgroundImageUpload($event)">
      </div>
      @if (label().backgroundImageUrl) {
      <label class="flex flex-col gap-1 text-sm font-medium">
        Ajuste do fundo (Fit)
        <select class="border p-2 rounded text-sm" [value]="label().backgroundObjectFit ?? 'cover'"
          (change)="setLabel({backgroundObjectFit: $any($event.target).value})">
          <option value="contain">Conter (Contain)</option>
          <option value="cover">Cobrir (Cover)</option>
          <option value="fill">Preencher (Fill)</option>
        </select>
      </label>
      }
    </div>

    <hr class="border-neutral-200 dark:border-neutral-800">

    <div class="flex gap-2">
      <app-button class="flex-1" [icon]="'file-text'" (click)="addText()">Texto</app-button>
      <app-button class="flex-1" [icon]="'image'" (click)="addImage()">Imagem</app-button>
    </div>

    <hr class="border-neutral-200 dark:border-neutral-800">

    <label class="flex items-center gap-2 text-sm font-medium cursor-pointer">
      <input type="checkbox" class="w-4 h-4" [checked]="showCenterGuide()"
        (change)="showCenterGuide.set($any($event.target).checked)">
      Mostrar linha guia
    </label>

    <hr class="border-neutral-200 dark:border-neutral-800">

    <div class="flex flex-col gap-2">
      <span class="text-sm font-bold">Camadas</span>
      <div class="flex flex-col gap-1 border rounded p-2 bg-neutral-50 dark:bg-neutral-800 max-h-60 overflow-y-auto">
        @for (layer of layers(); track layer.id) {
        <div
          class="flex items-center gap-2 p-1 hover:bg-neutral-100 dark:bg-neutral-600 dark:hover:bg-neutral-700 rounded transition cursor-pointer"
          [class.bg-blue-50]="layer.id === selectedId()" [class.border-blue-200]="layer.id === selectedId()"
          (click)="selectedId.set(layer.id)">
          <span class="text-xs truncate flex-1">{{ layer.name || layer.id }}</span>
          <div class="flex gap-1">
            <app-button size="small" [icon]="'chevron-up'" (buttonClick)="moveLayer(layer.id, 'up'); $event.stopPropagation()"></app-button>
            <app-button size="small" [icon]="'chevron-down'" (buttonClick)="moveLayer(layer.id, 'down'); $event.stopPropagation()"></app-button>
          </div>
        </div>
        } @empty {
        <p class="text-xs text-neutral-400 text-center py-2">Nenhuma camada</p>
        }
      </div>
    </div>

    <div class="mt-auto flex flex-col gap-2">
      <div class="grid grid-cols-2 gap-2">
        <app-button size="small" [fullWidth]="true" color="neutral" (buttonClick)="downloadJson()">Exportar JSON</app-button>
        <app-button size="small" [fullWidth]="true" color="neutral" (buttonClick)="jsonInput.click()">Importar JSON</app-button>
        <input #jsonInput type="file" accept=".json" class="hidden" (change)="uploadJson($event)">
      </div>
    </div>
  </aside>

  <main class="main flex-1 overflow-auto bg-neutral-100 dark:bg-neutral-900 p-8 flex flex-col items-center gap-6">
    <app-tag-canvas [label]="label()" [elements]="elements()" [selectedId]="selectedId()"
      [showCenterGuide]="showCenterGuide()" [placeholderValues]="placeholderValues()"
      (updateElement)="updateElement($event)" (select)="selectedId.set($event)"></app-tag-canvas>
  </main>

  <aside class="panel w-80 p-4 overflow-y-auto border-l border-neutral-200 dark:border-neutral-800">
    <h3 class="text-lg font-bold mb-4">Propriedades</h3>
    @if (selected()) {
    <div class="flex flex-col gap-4">
      <div>
        <span class="text-xs text-neutral-500 uppercase font-bold">Item Selecionado</span>
        <div class="flex flex-col gap-2 mt-1">
          <input type="text" class="border p-2 rounded w-full text-sm font-medium" [value]="selected()!.name ?? ''"
            placeholder="Nome do item" (input)="patchSelected({name: $any($event.target).value})">
          <div class="text-[10px] text-neutral-400 truncate">ID: {{ selected()!.id }}</div>
        </div>
      </div>

      <div class="flex gap-2">
        <label class="flex-1 flex flex-col gap-1 text-sm">
          X (mm)
          <input type="number" class="border p-2 rounded w-full" [value]="selected()!.xMm"
            (input)="patchSelected({xMm: +$any($event.target).value})" step="0.1">
        </label>
        <label class="flex-1 flex flex-col gap-1 text-sm">
          Y (mm)
          <input type="number" class="border p-2 rounded w-full" [value]="selected()!.yMm"
            (input)="patchSelected({yMm: +$any($event.target).value})" step="0.1">
        </label>
      </div>

      <div class="flex gap-2">
        <label class="flex-1 flex flex-col gap-1 text-sm">
          L (mm)
          <input type="number" class="border p-2 rounded w-full" [value]="selected()!.wMm"
            (input)="patchSelected({wMm: +$any($event.target).value})" step="0.1">
        </label>
        <label class="flex-1 flex flex-col gap-1 text-sm">
          A (mm)
          <input type="number" class="border p-2 rounded w-full" [value]="selected()!.hMm"
            (input)="patchSelected({hMm: +$any($event.target).value})" step="0.1">
        </label>
      </div>

      <hr class="border-neutral-100">

      @if (selected()!.type === 'text') {
      <label class="flex flex-col gap-1 text-sm font-medium">
        Conteúdo
        <textarea class="border p-2 rounded min-h-[80px] text-sm" [value]="$any(selected()).text"
          (input)="patchSelected({text: $any($event.target).value})"></textarea>
      </label>

      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium ">Estilo</span>
        <div class="flex gap-1">
          <app-button size="small" [icon]="'bold'" (buttonClick)="toggleBold()" [color]=" $any(selected()).fontWeight === 'bold' ? 'primary' : 'neutral' "></app-button>
          <app-button size="small" [icon]="'italic'" (buttonClick)="toggleItalic()" [color]=" $any(selected()).fontStyle === 'italic' ? 'primary' : 'neutral' "></app-button>
          <app-button size="small" [icon]="'underline'" (buttonClick)="toggleUnderline()" [color]=" $any(selected()).textDecoration === 'underline' ? 'primary' : 'neutral' "></app-button>
        </div>
      </div>

      <label class="flex flex-col gap-1 text-sm font-medium">
        Cor
        <input type="color" class="h-10 w-full p-1 border rounded" [value]="$any(selected()).color"
          (input)="patchSelected({color: $any($event.target).value})">
      </label>

      <label class="flex flex-col gap-1 text-sm font-medium">
        Fonte
        <select class="border p-2 rounded text-sm" [value]="$any(selected()).fontFamily"
          (change)="patchSelected({fontFamily: $any($event.target).value})">
          @for (f of fonts; track f) {
          <option [value]="f">{{ f }}</option>
          }
        </select>
      </label>

      <label class="flex flex-col gap-1 text-sm font-medium">
        Tamanho (pt)
        <input type="number" class="border p-2 rounded" [value]="$any(selected()).fontSizePt"
          (input)="patchSelected({fontSizePt: +$any($event.target).value})">
      </label>

      <label class="flex flex-col gap-1 text-sm font-medium">
        Alinhamento
        <select class="border p-2 rounded text-sm" [value]="$any(selected()).textAlign"
          (change)="patchSelected({textAlign: $any($event.target).value})">
          <option value="left">Esquerda</option>
          <option value="center">Centro</option>
          <option value="right">Direita</option>
          <option value="justify">Justificado</option>
        </select>
      </label>

      <div class="flex gap-2">
        <label class="flex-1 flex flex-col gap-1 text-sm font-medium">
          Espaçamento entre letras (px)
          <input type="number" class="border p-2 rounded w-full" min="0" step="0.5"
                 [value]="$any(selected()).letterSpacingPx ?? 0"
                 (input)="patchSelected({letterSpacingPx: +$any($event.target).value})">
        </label>
        <label class="flex-1 flex flex-col gap-1 text-sm font-medium">
          Espaçamento entre linhas
          <input type="number" class="border p-2 rounded w-full" min="0.5" max="3" step="0.1"
                 [value]="$any(selected()).lineHeight ?? 1.2"
                 (input)="patchSelected({lineHeight: +$any($event.target).value})"
                 placeholder="1.2"
                 title="1 = normal, 1.5 = 150%">
        </label>
      </div>
      } @else {
      <div class="flex flex-col gap-3">
        <label class="flex flex-col gap-1 text-sm font-medium">
          URL da Imagem
          <input type="text" class="border p-2 rounded text-xs" [value]="$any(selected()).src"
            (input)="patchSelected({src: $any($event.target).value})" placeholder="https://...">
        </label>

        <div class="flex flex-col gap-1">
          <span class="text-sm font-medium">Ou Upload</span>
          <span class="text-xs text-neutral-500">JPG ou PNG, máx. {{ maxFileSizeMb }}MB</span>
          <input type="file" accept="image/jpeg,image/png,.jpg,.jpeg,.png" class="text-xs"
            (change)="onImageUpload($event)">
        </div>

        <label class="flex flex-col gap-1 text-sm font-medium">
          Ajuste (Fit)
          <select class="border p-2 rounded text-sm" [value]="$any(selected()).objectFit"
            (change)="patchSelected({objectFit: $any($event.target).value})">
            <option value="contain">Conter (Contain)</option>
            <option value="cover">Cobrir (Cover)</option>
            <option value="fill">Preencher (Fill)</option>
          </select>
        </label>
      </div>
      }

      <hr class="border-neutral-100">

      <app-button
        [fullWidth]="true"
        color="danger"
        size="small"
        (buttonClick)="deleteSelected()">Excluir Item</app-button>
    </div>
    } @else {
    <div
      class="h-40 flex items-center justify-center border-2 border-dashed border-neutral-200 rounded text-neutral-400 text-sm">
      Nenhum item selecionado
    </div>
    }
  </aside>
</div>

<div class="layout flex overflow-hidden mt-4">
  <!-- Placeholders disponíveis para preview -->
  <div
    class="w-full rounded-xl border border-neutral-200 bg-white p-4 dark:border-neutral-700 dark:bg-neutral-800">
    <h3 class="text-sm font-bold text-neutral-800 dark:text-neutral-200 mb-3">
      Valores dos placeholders
    </h3>
    <p class="text-xs text-neutral-500 dark:text-neutral-400 mb-4">
      Use <code class="rounded bg-neutral-100 px-1 dark:bg-neutral-700">{{ '{{' }}productName{{ '}}' }}</code> no texto.
    </p>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      @for (p of placeholders; track p.key) {
      <label class="flex flex-col gap-1 text-xs">
        <span class="font-medium text-neutral-700 dark:text-neutral-300">{{ p.label }}</span>
        <span class="font-medium text-neutral-500 dark:text-neutral-400">Placeholder: {{ p.example }}</span>
        <input type="text"
          class="border border-neutral-300 rounded px-2 py-1.5 text-sm dark:border-neutral-600 dark:bg-neutral-900 dark:text-neutral-100"
          [placeholder]="p.example" [value]="placeholderValues()[p.key] ?? ''"
          (input)="setPlaceholderValue(p.key, $any($event.target).value)" />
      </label>
      }
    </div>
  </div>
</div>
